const defaultTheme = require('tailwindcss/defaultTheme');
const plugin = require('tailwindcss/plugin');
const { default: flattenColorPalette } = require("tailwindcss/lib/util/flattenColorPalette");

let containerScreens = { ...defaultTheme.screens };

// Delete the 2xl breakpoint from the object
delete containerScreens['2xl'];

module.exports = {
  content: [
    './app/**/*.{php,js}',
    './resources/**/*.{php,vue,js}',
    './config/tailwind-spacings.php',
  ],
  theme: {
    container: {
      screens: containerScreens,
    },
    fontFamily: {
      sans: ['Gantari', ...defaultTheme.fontFamily.sans],
    },
    extend: {
      backgroundPosition: {
        'right-center': 'right 1rem center'
      },
      backgroundImage: {
        'bullet-list': 'url(../images/bullet-point.svg)',
        'file-attachment': 'url(../images/file-attachment.svg)'
      },
      backgroundSize: {
        'bullet-list-mobile': 'calc(1.5 * 4.2666666666vw)',
        'bullet-list-desktop': 'calc(1.5 * 0.8333333333vw)',
      },
      colors: {
        'gray': {
          '50': '#F6F8FF',
          '100': '#EBEEFB',
          '200': '#BEC7EA',
          '300': '#8D95B5',
          '500': '#484E65',
          '600': '#2F3342',
          '900': '#1A1A1A',
        },
        'red': {
          '200': '#FF8A8D',
          '300': '#E13237',
          '500': '#9D0B0F',
          '700': '#810306',
        },
        'black': "#1A1A1A",
      },
      spacing: {
        '13': '3.375rem',
        '15': '3.75rem',
        'gutter': 'calc((100% - 77.125rem)/2)'
      },
      fontSize: {
        'xs': ['0.75rem', '1.25rem'],
        'sm': ['0.875rem', '1rem'],
        'base': ['1.125rem', '1.5625rem'],
        'lg': ['1.125rem', '1.375rem'],
        'xl': ['1.5rem', '2.065rem'],
        '2xl': ['2.125rem', '2.5rem'],
        '3xl': ['2.625rem', '3.125rem'],
        '4xl': ['4.5rem', '5.375rem']
      },
      transitionTimingFunction: {
        'zoom': 'cubic-bezier(0.25,0.46,0.45,0.94)',
      }
    },
  },
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/typography'),
    require('@tailwindcss/forms'),
    require('@tailwindcss/line-clamp'),
    plugin(function ({addVariant}) {
      addVariant('mobile-only', "@media screen and (max-width: theme('screens.md'))");
    }),
    plugin(function({matchUtilities, theme}) {
      matchUtilities(
        {
          'text-stroke': (value) => ({
            '-webkit-text-stroke': `var(--tw-stroke-width) ${value}`,
            textStroke: `var(--tw-stroke-width) ${value}`,
            '--tw-stroke-width': '1px',
          }),
        },
        {
          values: flattenColorPalette(theme("colors")), 
          type: "color" 
        }
      );

      matchUtilities(
        {
          'text-stroke-width': (value) => ({
            '--tw-stroke-width': value,
          })
        },
        {
          values: theme("spacing"),
        }
      )
    })
  ],
};
